import { Theme, alpha } from "@mui/material";

export const SizeStyles = (theme: Theme) => {
  return {
    sm: {
      fontSize: theme.fontSizes.xxs,
      width: "24px",
      height: "24px",
    },
    md: {
      fontSize: theme.fontSizes.md,
    },
    lg: {
      width: "48px",
      height: "48px",
      fontSize: theme.fontSizes.lg,
    },
  };
};

export const Variants = (theme: Theme) => {
  return {
    withLabel: {
      padding: `${theme.space._100} ${theme.space._100} ${theme.space._100} ${theme.space._300}`,
      backgroundColor: alpha(theme.colors["neutral.900"], 0.7)
    },
  }
}

export const BadgeStyles = (theme: Theme) => {
  return {
    leadBooker: {
      color: theme.colors["lime.500"],
      borderBlockColor: theme.colors["lime.500"],
    },
    underAge: {
      color: theme.colors["orange.500"],
      borderBlockColor: theme.colors["orange.500"],
    },
    underMinimumAge: {
      color: theme.colors["orange.500"],
      borderBlockColor: theme.colors["orange.500"],
    },
    generalAdmission: {
      color: theme.colors["pink.500"],
      borderBlockColor: theme.colors["pink.500"],
    },
    accessibilityRequired: {
      color: theme.colors["green.400"],
      borderBlockColor: theme.colors["green.400"],
    },
    vip: {
      color: theme.colors["orange.400"],
      borderBlockColor: theme.colors["orange.400"],
    },
    friendsAndFamily: {
      color: theme.colors["teal.500"],
      borderBlockColor: theme.colors["teal.500"],
    },
    generic: {
      color: theme.colors["neutral.400"],
      borderBlockColor: theme.colors["neutral.400"],
      fontSize: "0.7rem"
    },
    groupTicket: {
      color: theme.colors["yellow.400"],
      borderBlockColor: theme.colors["yellow.400"],
    },
    priority: {
      color: theme.colors["yellow.400"],
      borderBlockColor: theme.colors["yellow.400"],
    },
    prioritySparkles: {
      color: theme.colors["yellow.400"],
      borderBlockColor: theme.colors["yellow.400"],
    },
    // Consolidated flow (TTT-687/TTT-688)
    lastMinute: {
      color: theme.colors["blue.400"],
      borderBlockColor: theme.colors["blue.400"],
    },
    secondChance: {
      color: theme.colors["purple.400"],
      borderBlockColor: theme.colors["purple.400"],
    },
    // Amber, not red: nothing has gone wrong yet and the guest can still fix it.
    noAccount: {
      color: theme.colors["yellow.400"],
      borderBlockColor: theme.colors["yellow.400"],
    }
  };
};